export default __webpack_public_path__ + "cdf07d0fa240e5c22436a4bff84a7afc.svg";